<template>
  <div>
    <Form :label-width="100" inline @submit.native.prevent>
      <Row style="padding: 20px">
        <Col span="24">
          <FormItem label="模板名称:">
            <Input
              placeholder="请输入模板名称"
              v-model="params.name"
              clearable
              class="search"
            ></Input>
          </FormItem>
          <FormItem label="优惠券类型:">
            <Select style="width: 100px" v-model="params.ctype">
              <Option value="0">=全部=</Option>
              <Option v-for="(d, i) in CoupontempType" :key="i" :value="d.code"
                >{{ d.name }}
              </Option>
            </Select>
          </FormItem>
          <FormItem label="优惠券发放状态:">
            <Select style="width: 100px" v-model="params.status">
              <Option value="0">=全部=</Option>
              <Option
                v-for="(item, i) in CouponApplyStatus"
                :value="item.code"
                :key="i"
                >{{ item.name }}
              </Option>
            </Select>
          </FormItem>
        </Col>
        <Col span="24">
          <!-- <FormItem label="所属平台:">
            <label>
              <Select style="width:100px;" v-model="params.platformCode">
                <Option value="-1">=全部=</Option>
                <Option v-for="(item,index) in CouponPlatform"
                        :key="index" :value="item.code">{{ item.name }}
                </Option>
              </Select>
            </label>
          </FormItem> -->
          <FormItem>
            <Button
              type="primary"
              icon="md-search"
              @click="queryByCondition"
              v-access="'coupon.apply.list.query'"
              >查询</Button
            >
          </FormItem>
        </Col>
      </Row>
    </Form>
    <Row style="padding: 20px">
      <Table
        class="table"
        border
        stripe
        height="500"
        :loading="loading"
        :columns="columnlist"
        :data="CouponApplyList"
      >
        <template slot-scope="{ row,  }" slot="statusName">
          <span v-if="row.status === 1" style="color: black">待审核</span>
          <span v-if="row.status === 2" style="color: black">已审核</span>
          <span v-if="row.status === 3" style="color: red">已取消</span>
          <span v-if="row.status === 4" style="color: red">审核失败</span>
          <span v-if="row.status === 5" style="color: green">已发放</span>
          <span v-if="row.status === 6" style="color: red">发放失败</span>
          <span v-if="row.status === 7" style="color: red">发放后撤回</span>
        </template>
        <template slot-scope="{ row, index }" slot="status">
          <!--          {code: 1, name: "待审核"}, {code: 2, name: "已审核"}, {code: 3, name: "已取消"}, {code: 4, name: "审核失败"},-->
          <!--          {code: 5, name: "已发放"}, {code: 6, name: "发放失败"}, {code: 7, name: "发放后撤回"}-->
          <span>
            <a
              type="text"
              size="small"
              style="margin-right: 5px"
              v-access="'coupon.apply.list.details'"
              @click="viewCouponApply(row, index)"
              >查看</a
            >
          </span>
          <span v-if="row.status === 1">
            <a
              type="text"
              size="small"
              style="margin-right: 5px"
              v-access="'coupon.apply.list.edit'"
              @click="editCouponApply(row, index)"
              >编辑</a
            >
            <a
              type="text"
              size="small"
              style="margin-right: 5px"
              v-access="'coupon.apply.list.edit'"
              @click="auditCouponApply(row, index)"
              >审核通过</a
            >
            <a
              type="text"
              size="small"
              style="margin-right: 5px"
              v-access="'coupon.apply.list.edit'"
              @click="rejectCouponApply(row, index)"
              >审核拒绝</a
            >
            <a
              type="text"
              size="small"
              style="margin-right: 5px"
              v-access="'coupon.apply.list.edit'"
              @click="cancelCouponApply(row, index)"
              >取消</a
            >
            <!--            <a-->
            <!--              type="text"-->
            <!--              size="small"-->
            <!--              style="margin-right: 5px"-->
            <!--              @click="deleteCouponApply(row, index)"-->
            <!--            >删除</a>-->
          </span>
          <span v-if="row.status === 2" style="color: black">
            <a
              type="text"
              size="small"
              style="margin-right: 5px"
              v-access="'coupon.apply.list.edit'"
              @click="releaseCouponApply(row, index)"
              >发放</a
            >
          </span>
          <span v-if="row.status === 4">
            <a
              type="text"
              size="small"
              style="margin-right: 5px"
              v-access="'coupon.apply.list.edit'"
              @click="editCouponApply(row, index)"
              >编辑</a
            >
          </span>
          <span v-if="row.status === 5" style="color: green">
            <a
              type="text"
              size="small"
              style="margin-right: 5px"
              v-access="'coupon.apply.list.edit'"
              @click="reCallCouponApply(row, index)"
              >发放撤回</a
            ></span
          >
        </template>
      </Table>
    </Row>
    <Row type="flex" justify="end">
      <page
        :total="totalCnt"
        :page-size="params.pageSize"
        :page-size-opts="[10, 20, 30, 50]"
        @on-change="pageNumChange"
        @on-page-size-change="pageSizeChange"
        show-total
        show-sizer
        class-name="pagination justify-content-end mg-10"
      />
    </Row>
  </div>
</template>

<script>
const columnlist = [
  {
    title: "优惠券编码",
    key: "code",
    tooltip: true,
    width: 250,
  },
  {
    title: "名称",
    key: "name",
    tooltip: true,
    width: 250,
  },
  {
    title: "优惠券类型",
    key: "ctypeName",
    width: 200,
  },
  {
    title: "批次号",
    key: "batchNo",
    width: 200,
    tooltip: true,
  },
  {
    title: "优惠券发放状态",
    slot: "statusName",
    width: 200,
  },
  {
    title: "创建时间",
    key: "createtime",
    width: 120,
  },
  {
    title: "审核时间",
    key: "audittime",
    width: 120,
  },
  {
    title: "执行时间",
    key: "finishtime",
    width: 120,
  },
  // {
  //   title: '所属平台',
  //   key: 'platformName',
  //   width: 200
  // },
  // {
  //   title: '备注',
  //   key: 'remark',
  //   width: 200,
  //   tooltip: true
  // },
  {
    title: "操作",
    slot: "status",
    width: 300,
    fixed: "right",
  },
];
export default {
  name: "couponApplyList",
  data() {
    return {
      loading: false,
      columnlist,
      CoupontempType: [],
      CouponApplyStatus: [],
      CouponPlatform: [],
      params: {
        code: "",
        name: "",
        platformCode: "-1",
        ctype: "0",
        status: "0",
        pageSize: 10,
        pageNum: 1,
      },
      CouponApplyList: [],
      totalCnt: 0,
    };
  },
  methods: {
    showPlatformName(code) {
      for (let i = 0; i < this.CouponPlatform.length; i++) {
        if (code === this.CouponPlatform[i].code) {
          return this.CouponPlatform[i].name;
        }
      }
    },
    showCouponApplyStatusName(code) {
      for (let i = 0; i < this.CouponApplyStatus.length; i++) {
        if (code === this.CouponApplyStatus[i].code) {
          return this.CouponApplyStatus[i].name;
        }
      }
    },
    showCouponTypeName(code) {
      for (let i = 0; i < this.CoupontempType.length; i++) {
        if (code === parseInt(this.CoupontempType[i].code)) {
          return this.CoupontempType[i].name;
        }
      }
    },
    pageNumChange(p) {
      this.params.pageNum = p;
      this.queryCouponApplylist();
    },
    pageSizeChange(p) {
      this.params.pageSize = p;
      this.queryCouponApplylist();
    },
    queryByCondition() {
      this.params.pageNum = 1;
      this.queryCouponApplylist();
    },
    queryCoupontemptype() {
      let http = "couponTemplateType";
      this.$api[http]({}).then((res) => {
        if (res.code === "200") {
          //this.$Message.success('查询优惠券类型枚举成功');
          let t = res.data.CoupontempType;
          let t_keys = Object.keys(t);
          for (let i = 0; i < t_keys.length; i++) {
            this.CoupontempType.push({ code: t_keys[i], name: t[i + 1] });
          }
        } else {
          this.$Message.error("查询优惠券类型枚举失败.");
        }
      });
    },
    queryCouponApplyStatus() {
      this.CouponApplyStatus = [
        { code: 1, name: "待审核" },
        { code: 2, name: "已审核" },
        { code: 3, name: "已取消" },
        { code: 4, name: "审核失败" },
        { code: 5, name: "已发放" },
        { code: 6, name: "发放失败" },
        { code: 7, name: "发放后撤回" },
      ];
    },
    queryBusiPlatform() {
      let http = "couponqueryBusiPlatform";
      this.$api[http]({}).then((res) => {
        if (res.code === "200") {
          //this.$Message.success('查询优惠券业务平台枚举成功');
          this.CouponPlatform = res.data.CouponPlatform;
        } else {
          this.$Message.error("查询优惠券业务平台枚举失败.");
        }
      });
    },
    queryCouponApplylist() {
      this.loading = true;
      let http = "queryCouponApplyList";
      this.$api[http](this.params).then((res) => {
        if (res.code === "200") {
          this.$Message.success("查询优惠券发放申请列表成功");
          this.CouponApplyList = res.data.list;
          this.totalCnt = res.data.total;
          this.CouponApplyList.forEach((t) => {
            t.createtime = t.createtime ? t.createtime.substr(0, 10) : "";
            t.audittime = t.audittime ? t.audittime.substr(0, 10) : "";
            t.finishtime = t.finishtime ? t.finishtime.substr(0, 10) : "";
            t.platformName = this.showPlatformName(t.platformCode);
            t.statusName = this.showCouponApplyStatusName(t.status);
            t.ctypeName = this.showCouponTypeName(t.ctype);
          });
        } else {
          this.$Message.error("查询优惠券发放申请列表失败.");
        }
        this.loading = false;
      });
    },

    viewCouponApply(row, index) {
      this.$router.push({
        name: "coupon_apply_create",
        query: {
          code: row.templateCode,
          applyCode: row.code,
          viewMode: true,
        },
      });
    },
    editCouponApply(row, index) {
      this.$router.push({
        name: "coupon_apply_create",
        query: {
          code: row.templateCode,
          applyCode: row.code,
        },
      });
    },
    auditCouponApply(row, index) {
      this.$Modal.confirm({
        title: "审批优惠券",
        content: "<p>是否要审批该优惠券？</p>",
        onOk: () => {
          let query = {
            code: row.code,
            operator:
              window.sessionStorage.getItem("name") +
              "(" +
              window.sessionStorage.getItem("loginId") +
              ")",
          };
          this.$api["auditCouponApply"](query).then((res) => {
            if (res.code === "200") {
              if (res.data.code === "0000") {
                this.$Message.success("审核优惠券发放申请成功.");
                row.status = 2;
              }
            } else {
              this.$Message.error("审核优惠券发放申请失败.");
            }
          });
        },
        onCancel: () => {},
      });
    },
    rejectCouponApply(row, index) {
      this.$Modal.confirm({
        title: "拒审优惠券",
        content: "<p>是否要拒审该优惠券？</p>",
        onOk: () => {
          let query = {
            code: row.code,
            operator:
              window.sessionStorage.getItem("name") +
              "(" +
              window.sessionStorage.getItem("loginId") +
              ")",
          };
          this.$api["rejectCouponApply"](query).then((res) => {
            if (res.code === "200") {
              if (res.data.code === "0000") {
                this.$Message.success("拒审优惠券发放申请成功.");
                row.status = 4;
              }
            } else {
              this.$Message.error("拒审优惠券发放申请失败.");
            }
          });
        },
        onCancel: () => {},
      });
    },
    // deleteCouponApply(row, index) {
    //   let http = 'queryTemplateDetail';
    //   let query = {code: row.code};
    //   this.$api[http](query).then((res) => {
    //     if (res.code === '200') {
    //       if (res.data.status !== '0') {
    //         this.$Message.error('优惠券模板为停用状态,不能申请发放.');
    //       } else {
    //         this.$router.push({
    //           name: "coupon_apply_create",
    //           params: {
    //             code: row.code,
    //           }
    //         });
    //       }
    //     } else {
    //       this.$Message.error('启用优惠券模板失败.');
    //     }
    //   });
    // },
    releaseCouponApply(row, index) {
      this.$Modal.confirm({
        title: "发放优惠券",
        content: "<p>是否要发放该优惠券？</p>",
        onOk: () => {
          let query = {
            code: row.code,
            operator:
              window.sessionStorage.getItem("name") +
              "(" +
              window.sessionStorage.getItem("loginId") +
              ")",
          };
          this.$api["realeaseCouponApply"](query).then((res) => {
            if (res.code === "200") {
              if (res.data.code === "0000") {
                this.$Message.success("发放优惠券成功.");
                row.status = 5;
              }
            } else {
              this.$Message.error("发放优惠券失败.");
            }
          });
        },
        onCancel: () => {},
      });
    },
    cancelCouponApply(row, index) {
      this.$Modal.confirm({
        title: "取消优惠券",
        content: "<p>是否要取消该优惠券？</p>",
        onOk: () => {
          let query = {
            code: row.code,
            operator:
              window.sessionStorage.getItem("name") +
              "(" +
              window.sessionStorage.getItem("loginId") +
              ")",
          };
          this.$api["cancelCouponApply"](query).then((res) => {
            if (res.code === "200") {
              if (res.data.code === "0000") {
                this.$Message.success("取消优惠券发放申请成功.");
                row.status = 3;
              }
            } else {
              this.$Message.error("取消优惠券发放申请失败.");
            }
          });
        },
        onCancel: () => {},
      });
    },
    reCallCouponApply(row, index) {
      this.$Modal.confirm({
        title: "撤回优惠券",
        content: "<p>是否要撤回该批次优惠券？</p>",
        onOk: () => {
          let query = {
            code: row.code,
            operator:
              window.sessionStorage.getItem("name") +
              "(" +
              window.sessionStorage.getItem("loginId") +
              ")",
          };
          this.$api["recallCouponApply"](query).then((res) => {
            if (res.code === "200") {
              if (res.data.code === "0000") {
                this.$Message.success("优惠券批次撤回成功.");
                row.status = 7;
              }
            } else {
              this.$Message.error("优惠券批次撤回失败.");
            }
          });
        },
        onCancel: () => {},
      });
    },
  },
  created() {
    this.queryBusiPlatform();
    this.queryCouponApplyStatus();
  },
  watch: {
    CouponPlatform(n, o) {
      this.queryCoupontemptype();
    },
    CoupontempType(n, o) {
      this.queryCouponApplylist();
    },
  },
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/coupon/apply/list.vue